/* rdev-common.js — v2026-08-26 resync marker.
   The live theme was serving a pre-Aug-6 copy of this file (its mux autoplay
   guard missing, throwing "video.play is not a function"), while every git
   branch carried the fix — one file drifted, likely via a theme-editor edit.
   This header exists to change the file's content hash so the GitHub sync
   rewrites the live copy. Safe to remove in any later real edit. */
document.addEventListener("DOMContentLoaded", () => {
  const tryPlay = video => {
    video.muted = true; // required — programmatic play() is only allowed while muted
    if (typeof video.play !== 'function') return; // custom element not upgraded yet
    const p = video.play();
    if (!p || typeof p.catch !== 'function') return;
    p.catch(err => {
      // AbortError means a newer load() superseded this play() — expected while
      // mux-player upgrades and swaps in its HLS source. Retry once it has data
      // instead of warning; the video does end up playing either way.
      if (err && err.name === 'AbortError') {
        video.addEventListener('loadeddata', () => {
          const r = video.play();
          if (r && typeof r.catch === 'function') r.catch(() => {});
        }, { once: true });
        return;
      }
      console.warn("Autoplay blocked:", err);
    });
  };
  const pause = video => { try { if (typeof video.pause === 'function') video.pause(); } catch (e) {} };

  /* Play ONLY while visible. The gallery players carry preload="none" and no autoplay
     attribute, so an off-screen slide fetches no HLS manifest and no segments at all —
     nothing streams for a slide the shopper never swipes to. Inactive Swiper slides sit
     outside the viewport horizontally, so they never intersect. */
  let io = null;
  const observeVideos = () => {
    const vids = document.querySelectorAll('.my-video');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) { vids.forEach(tryPlay); return; }
    if (!io) {
      io = new IntersectionObserver(entries => {
        entries.forEach(e => { e.isIntersecting ? tryPlay(e.target) : pause(e.target); });
      }, { threshold: 0.25 });
    }
    vids.forEach(v => { if (!v.__fonVideoObserved) { v.__fonVideoObserved = true; io.observe(v); } });
  };

  observeVideos();
  // mux-player is loaded after window 'load' (see fon-scripts-footer) — re-scan once it upgrades
  if (window.customElements) {
    customElements.whenDefined('mux-player').then(observeVideos).catch(() => {});
  }
  window.addEventListener('load', () => { observeVideos(); setTimeout(observeVideos, 1500); });
});



(function () {
    function handleUrlChange() {
        var url = window.location.href;

        var id = url.includes("/a/account/subscriptions/")
            ? url.split("/a/account/subscriptions/")[1]
            : null;

        if (id) {
            setTimeout(function () {
                $.get(`https://app.usefon.com/skio/get-widget.php?id=${id}`, function (html) {
                    if (!$('#skio-fon-progress').length) {
                        $('[data-skio-name="subscription-details-header-container"]')
                            .before('<div id="skio-fon-progress">' + html + '</div>');
                    }
                });
            }, 5000);
        }
    }

    // Run on initial load
    handleUrlChange();

    // Detect back/forward navigation
    window.addEventListener('popstate', handleUrlChange);

    // Monkey-patch pushState and replaceState
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    history.pushState = function () {
        originalPushState.apply(this, arguments);
        handleUrlChange();
    };

    history.replaceState = function () {
        originalReplaceState.apply(this, arguments);
        handleUrlChange();
    };
})();


/* Infinite CSS animations (marquee .carousel-track, diagonalShimmer, shimmerDark, ...)
   otherwise run for the whole page lifetime even far below the fold. Each running
   animation forces a style recalc every frame, which burns main-thread for motion
   nobody can see — and makes the DevTools Styles panel repaint constantly.
   Found via getAnimations() rather than a selector list, so new decorative animations
   are covered automatically. */
function fonPauseOffscreenAnims() {
  if (!('IntersectionObserver' in window) || !document.getAnimations) return;
  var seen = window.__fonAnimSeen || (window.__fonAnimSeen = new WeakSet());
  var io = window.__fonAnimIO || (window.__fonAnimIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      e.target.classList.toggle('fon-anim-offscreen', !e.isIntersecting);
    });
  }, { rootMargin: '150px 0px' }));

  document.getAnimations().forEach(function (a) {
    if (!a.effect || a.effect.getTiming().iterations !== Infinity) return;
    var t = a.effect.target;
    if (!t || t.nodeType !== 1 || seen.has(t)) return;
    seen.add(t);
    t.classList.add('fon-anim-offscreen');   // start paused; the observer corrects at once
    io.observe(t);
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', fonPauseOffscreenAnims);
} else {
  fonPauseOffscreenAnims();
}
/* re-scan for animations that only start once their section/CSS has loaded */
window.addEventListener('load', function () {
  fonPauseOffscreenAnims();
  setTimeout(fonPauseOffscreenAnims, 2000);
});

/* Stop a continuous-autoplay Swiper while it is off screen — it otherwise
   animates (and burns main-thread) for the whole page lifetime. */
function pauseOffscreen(el, sw) {
  if (!el || !sw || !sw.autoplay || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) { sw.autoplay.start(); }
    else { sw.autoplay.stop(); }
  }, { rootMargin: '100px 0px' });
  io.observe(el);
}

jQuery(document).ready(function($) {



  // $(document).on('click', '.market-toggle', function (e) {
  //   e.preventDefault();
  //   e.stopPropagation();

  //   const $menu = $('.fon-menu-market-container');

  //   if ($menu.hasClass('active')) {
  //     $menu.css('opacity', '0');
  //     setTimeout(() => $menu.removeClass('active'), 600);
  //   } else {
  //     $menu.addClass('active');
  //     setTimeout(() => $menu.css('opacity', '1'), 10);
  //   }
  // });

  // $(document).on('click', function (e) {
  //   if (!$(e.target).closest('.fon-menu-market-container, .market-toggle').length) {
  //     const $menu = $('.fon-menu-market-container');
  //     $menu.css('opacity', '0');
  //     setTimeout(() => $menu.removeClass('active'), 600);
  //   }
  // });
  

  // Clone Desktop Panel to Desktop

  if ($(window).width() < 768) {
    var content = $('.fon-menu-market-container').html();
    $('.fon-mobile-menu-products[data-accord="market"]').html(content);
    $('.fon-mobile-menu-products[data-accord="learn"]').html($('[data-action="learn"] .fon-mobile-menu-products').html());
  }

// Open first on load
// Open first on load
  $('.fon-mobile-menu-products[data-accord]').first().addClass('open').css('overflow', 'visible');

  $('p.nav-mobile-heading[data-accord]').on('click', function () {
    var accord = $(this).data('accord');
    var $panel = $('.fon-mobile-menu-products[data-accord="' + accord + '"]');
    var isOpen = $panel.hasClass('open');

    // Reset overflow before closing (so close animates properly)
    $('.fon-mobile-menu-products[data-accord]').css('overflow', 'hidden').removeClass('open');

    if (!isOpen) {
      $panel.addClass('open').one('transitionend', function () {
        $(this).css('overflow', 'visible');
      });
    }
  });


  $(window).on('load', function() {
      if (typeof AOS !== 'undefined') {
          AOS.init({
              duration: 800, // animation time
              once: true     // run only once
          });
      } else {
          console.warn('AOS library is not loaded.');
      }
  });




  if (window.location.href != 'https://usefon.com/pages/retailers-portal'){
      localStorage.setItem('currentPage', window.location.href);
    }

    $('a[href="#blackfriday"]').on('click', function(e) {
      e.preventDefault(); // Prevent default anchor jump
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'Wdydk7']);
    });



    $('.zoom-effect-image').each(function() {
    $(this).wrap('<div class="zoom-effect-image-wrap"></div>');
  });
  $(window).on("scroll resize", function () {
    $(".zoom-effect-image-wrap").each(function () {
      var $this = $(this);
      var rect = this.getBoundingClientRect();

      // Check if fully visible in viewport
      if (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || $(window).height()) &&
        rect.right <= (window.innerWidth || $(window).width())
      ) {
        $this.addClass("active");
      } else {
        $this.removeClass("active");
      }
    });
  });



    const sectionsClinically = document.querySelectorAll(".section-onefit-clinically");

    if (sectionsClinically.length) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("in-view");
            } else {
              entry.target.classList.remove("in-view");
            }
          });
        },
        {
          threshold: 0.7 // show/hide when 20% is visible
        }
      );

      sectionsClinically.forEach((section) => observer.observe(section));
    }




  $(document).on('click', '.fon-mobile-menu-image', function () {
    
    // $('.fon-mobile-menu-container').toggleClass('mobile-trigged');
    // if (!$('.fon-menu-dropdown').hasClass('active')){
     
    // }else{
    //   closeMobileMenu();
    // }

    if ($('.fon-mobile-menu-container').hasClass('mobile-trigged') ){
      closeMobileMenu();
      $('.fon-mobile-menu-container').removeClass('mobile-trigged');
    }else{
      $('.fon-mobile-menu-container').addClass('mobile-trigged');
      $('.fon-menu-dropdown').first().trigger('click');
    }
    
  });


  $(document).on('click', '.fon-mobile-close-image', function () {
    
      $('.fon-mobile-menu-container').removeClass('mobile-trigged');
      closeMobileMenu();
   
  });
  $(document).on('click', '.fon-menu-link-get-started', function () {
    
      $('.fon-mobile-menu-container').removeClass('mobile-trigged');
      closeMobileMenu();
   
  });


  function isMobile() {
  return window.matchMedia('(max-width: 768px)').matches;
}

  function handleMenuAction() {
    var $this = $(this);

    $('.fon-mobile-menu-content').show();

    $this.siblings().removeClass('active');
    $this.addClass('active');

    var action = $this.attr('data-action');
    var $target = $('.mobile-menu-content[data-action="' + action + '"]');


       // Close all, then open the target
    $('.mobile-menu-content').not($target).hide();

    $('.fon-mobile-menu-content').addClass('active');
    $('.fon-mobile-menu-container').attr('data-panel', action);
    $target.stop().fadeIn(600);
    // $target.fadeIn(600).fadeIn(300);


  }

  // Desktop — mouseover only
  $(document).on('mouseover', '.fon-mobile-menu ul li.fon-menu-dropdown', function () {
    if (!isMobile()) {
      handleMenuAction.call(this);
    }
  });

  // Mobile — click only
  $(document).on('click', '.fon-mobile-menu ul li.fon-menu-dropdown', function () {
    if (isMobile()) {
      handleMenuAction.call(this);
    }
  });



  // Remove active selecctions
  $(document).on("mouseleave", ".fon-mobile-menu-container", function() {
    closeMobileMenu();
  });


  // var test = $('li.fon-menu-dropdown[data-action="market"');
  // handleMenuAction.call(test);


  // Close on click outside
  $(document).on("click", function(e) {
    if (!$(e.target).closest(".fon-mobile-menu-container").length) {
      $('.fon-mobile-menu-container').removeClass('mobile-trigged');
      closeMobileMenu();
    }
  });

  // Reusable close function
  function closeMobileMenu() {
    
    var action = $('.fon-mobile-menu ul li.active').attr('data-action');
    var $target = $('.mobile-menu-content[data-action="' + action + '"]');
    
    // $('.fon-mobile-menu-content').removeClass('active');
    
    // $('.fon-mobile-menu-content').removeClass('active');
      
    $('.fon-mobile-menu-content').stop(true, true).fadeOut(function(){
      $target.hide();
      $('.fon-mobile-menu ul li').removeClass('active');
    });

    
    
  }
    


  if ($('body').hasClass('name-list-collections')) {
    window.location.href = "https://usefon.com/collections/all";
  }


  


  var marqueeSpeed = 100; // default for desktop
  var marqueeGap = 100; // default for desktop

  if (window.innerWidth <= 767) { 
    // mobile devices
    marqueeSpeed = 30; // slower on mobile
    marqueeGap = 40; // slower on mobile
  }

  // marquee init disabled (perf): .marquee-content only exists in section-fon-why-fon,
  // which is disabled in header-group.json. Re-enable this + the jquery.marquee.min.js
  // load in theme.liquid if that section is turned back on.
  // $('.marquee-content').marquee({
  //   speed: marqueeSpeed,
  //   gap: marqueeGap,
  //   delayBeforeStart: 0,
  //   direction: 'left',
  //   duplicated: true,
  //   pauseOnHover: true,
  //   allowCss3Support: true
  // });

  

  $(document).on('click','.link-cart-drawer',function(){
    FonCartDrawer.openCartDrawer();
    FonCartDrawer.updateCartDrawer();
  });
  $(document).on('click','.fon-menu-link-cart',function(){
    FonCartDrawer.openCartDrawer();
    FonCartDrawer.updateCartDrawer();
  });

  if ($('.shopify-section--main-cart').length) {
    setTimeout(() => {
      FonCartDrawer.openCartDrawer();
      FonCartDrawer.updateCartDrawer();
    }, 2000);
  }

  
  $('.show-country-selector').html($('.current-country-selector').html()).show();;
  
  // Only show on first visit
  if (Shopify.country != 'AU' && Shopify.country != 'NZ') {

    $('body').addClass('body-non-au');
    
    if (!localStorage.getItem('countryPopupShown')) {
      $.magnificPopup.open({
        items: {
          src: '#country-popup',
          type: 'inline'
        },
         modal: false, // disables closing by clicking outside,
        closeBtnInside: true
      });
    }

    localStorage.setItem('countryPopupShown', 'true');
  }
  $(document).on('click','.show-country-selector',function(){
    localStorage.setItem('countryPopupShown', 'true');
    $.magnificPopup.open({
        items: {
          src: '#country-popup',
          type: 'inline'
        },
        modal: false, // disables closing by clicking outside,
        closeBtnInside: true
      });;
  });

  $('[data-select-country="' + Shopify.country + '"]').addClass('active');

  
  $('body').addClass('country-'+Shopify.country);

  // if (window.location.pathname === '/policies/shipping-policy') {
  //   window.location.href = '/products/onefit';
  // }


function handlePageScroll() {
  let currentScroll = $(window).scrollTop();
  if (currentScroll >= 1) {
    $('body').addClass('page-scrolled');
  } else {
    $('body').removeClass('page-scrolled');
  }
}

handlePageScroll(); // onload
$(window).on('scroll', handlePageScroll); // on scroll

// if ($('.name-index').length){
//   $('body').addClass('scrolled');
// } else {
//   let lastScrollTop = -1;
//   $(window).on('scroll', function () {

//     let currentScroll = $(this).scrollTop();
//     if (currentScroll >= 25 && lastScrollTop < 25) {
//       $('body').addClass('scrolled');
//     } else if (currentScroll < 1 && lastScrollTop >= 1) {
//       $('body').removeClass('scrolled');
//     }
//     lastScrollTop = currentScroll;

//   });
// }
  


  $(document).on('click', '.close-popup', function() {
      $.magnificPopup.close();
  });


  window.addEventListener("klaviyoForms", function(e) { 

        console.log('e.detail.type',e.detail.type);
        if (e.detail.type == 'close') {
            $.magnificPopup.close();
            $('body').removeClass('stepSubmit');
        }

    

        if (e.detail.type == 'stepSubmit') {
            $('body').addClass('stepSubmit');
        }
    
    });
  
  
  $('.popup-inline').magnificPopup({
    type: 'inline',
    callbacks: {
          close: function() {
              console.log('Popup closed');
              $('body').removeClass('stepSubmit');
          }
      }
  });
  
  
  $('.make-it-wabble').on('click', function() {
    $(this).addClass('wobble'); // Add wobble class
    
   // Remove wobble class after 2 seconds
    setTimeout(() => {
      $(this).removeClass('wobble');
    }, 3000); // 2000ms = 2 seconds

    
  });

  $(document).on('click','.faq',function(){
      
        if (!$(this).hasClass('active')){
            $('.faq').removeClass('active');
            $(this).addClass('active');
        }else{
            $(this).removeClass('active');
        }
        
    });


   $(document).on('click','.q-a',function(){
      
        if (!$(this).hasClass('active')){
            $('.q-a').removeClass('active');
            $(this).addClass('active');
        }else{
            $(this).removeClass('active');
        }
        
    });

  if ($('.section-page-ingredients ul.list-group').length){
  
    var ingredientsOptionKey = '.section-page-ingredients ul.list-group li';
    $(document).on('click',ingredientsOptionKey,function(){

      
      $(ingredientsOptionKey).removeClass('active');
      $(this).addClass('active');
      
      var selection = $(this).attr('data-filter');

      if (selection == 'onelife'){
        $('ul.list-group.list-group-horizontal.mt-2').fadeOut();
      }else{
        $('ul.list-group.list-group-horizontal.mt-2').fadeIn();
      }

     
      $('.section-page-ingredients .ingredient').removeClass('active').addClass('filtered');
      $('[data-categories*="' + selection + '"]').addClass('active');
      
    });

    $('.section-page-ingredients li.list-group-item.active').trigger('click');
  }


  $(document).on('click','.section-page-ingredients .ingredient',function(){
       

        var html = '';
        $('body').addClass('ingredient-popup')
        html+='<div class="white-popup ingredient-popup">' + $(this).html() + '</div>';

        $.magnificPopup.open({
          items: {
            src: html, // HTML content
            type: 'inline'
          },
          closeBtnInside: true,
          callbacks: {
            close: function () {
              $('body').removeClass('ingredient-popup');
            }
          }
        });
    });


  $('.popup-image').magnificPopup({
      type: 'image',
      closeOnContentClick: true,
    });



  function initCommonSwiperOnMobile(key, slidesPerView = 1.2) {
        const parentElement = $(key);
    
      if ($(window).width() <= 820 && !parentElement.hasClass('swiper-initialized')) {
        // Add Swiper classes
        parentElement.addClass('swiper-container swiper-initialized');
        parentElement.children().wrapAll('<div class="swiper-wrapper"></div>');
        parentElement.find('.swiper-wrapper').children().addClass('swiper-slide');
    
        // Initialize Swiper
        new Swiper(key, {
          slidesPerView: slidesPerView,
          spaceBetween: 10,
          loop: true,
          speed: 300, // No transition, instant slide change
          // autoplay: {
          //   delay: 2000, // 3 seconds
          //   disableOnInteraction: false, // Keep autoplay active after interaction
          // },
          pagination: {
            el: key + ' .swiper-pagination',
            clickable: true,
          },
        });
    
        // Add pagination if not exists
        if (!parentElement.find('.swiper-pagination').length) {
          parentElement.append('<div class="swiper-pagination"></div>');
        }
      } else if ($(window).width() > 768 && parentElement.hasClass('swiper-initialized')) {
        // Destroy Swiper instance and reset structure
        parentElement.removeClass('swiper-container swiper-initialized');
        const slides = parentElement.find('.swiper-slide').unwrap(); // unwrap from swiper-wrapper
        slides.removeClass('swiper-slide');
        parentElement.find('.swiper-pagination').remove();
      }
    }
    
    initCommonSwiperOnMobile('.section-ingredients-reviews .row',1.3);
    // initCommonSwiperOnMobile('.library-articles-container',1.3);
  
    

  

    $(document).ready(function () {
      $('.popup-video').on('click', function (e) {
          e.preventDefault();
  
          var videoUrl = $(this).attr('data-href'); // Get the video URL from data-href
  
          $.magnificPopup.open({
              items: {
                  src: `<div class="white-popup" style="background: #fff; padding: 0px; max-width: 800px; margin: auto; text-align: center; border-radius: 10px;">
                          <video controls autoplay style="width:100%; max-height: 80vh;">
                              <source src="${videoUrl}" type="video/mp4">
                              Your browser does not support the video tag.
                          </video>
                        </div>`,
                  type: 'inline'
              },
              midClick: true,
              callbacks: {
                  close: function () {
                      $('video').each(function () {
                          this.pause(); // Pause video when closing
                      });
                  }
              }
          });
      });
  });


  $("[data-trigger]").on("click", function (event) {
        event.preventDefault();
        var target = $(this).attr("data-trigger");
        var $targetElement = $("[data-target='" + target + "']");

        if ($targetElement.length) {
            $("html, body").animate(
                {
                    scrollTop: $targetElement.offset().top - 100,
                },
                800 // Adjust the speed of the animation (in milliseconds)
            );
        }
    });

  const swiper = new Swiper(".mobile-carousel", {
    slidesPerView: "auto",  // Adjusts to each slide's width
    spaceBetween: 10,       // Adjust spacing as needed
    loop: true,             // Enables infinite scrolling
    speed: 3000,            // Increase speed for smoother effect
    autoplay: {
      delay: 0,             // Ensures no pause between transitions
      disableOnInteraction: false,
      reverseDirection: false, // Ensures forward movement
    },
    freeMode: true,         // Enables smooth continuous scrolling
    
  });
  pauseOffscreen(document.querySelector('.mobile-carousel'), swiper);




  
    
  const wrappers = document.querySelectorAll('video-media-x');

  wrappers.forEach(wrapper => {
    const video = wrapper.querySelector('video');


    wrapper.setAttribute('loaded', '');

    if (!video) return;

    wrapper.addEventListener('click', () => {
      const isPaused = video.paused;

      // Pause all other videos
      wrappers.forEach(otherWrapper => {
        const otherVideo = otherWrapper.querySelector('video');
        if (otherVideo && otherWrapper !== wrapper) {
          otherVideo.pause();
          // otherWrapper.setAttribute('pause', '');
          otherWrapper.removeAttribute('play');
          otherWrapper.removeAttribute('pause-current');
        }
      });

      // Toggle this video
      if (isPaused) {
        video.play();
        wrapper.setAttribute('play', '');
        wrapper.removeAttribute('pause');
      } else {
        video.pause();
        wrapper.setAttribute('pause-current', '');
        wrapper.removeAttribute('play');
      }
    });
  });

  $(document).on('click','[data-notify-me]',function(){

      var variantID = $(this).attr('data-variant-id');
      // Force Klaviyo to check for new forms in the DOM
if (window._klOnsite && typeof window._klOnsite.reloadForms === "function") {
    window._klOnsite.reloadForms();
}
      $.magnificPopup.open({
        items: {
          src: '#klaviyo-oos-' + variantID // This is the ID of the hidden div
        },
        type: 'inline'
      });

  });
  

    if ($('.hero-section-wrapper').length){
    $('.hero-section-wrapper').each(function () {
      const urlParams = new URLSearchParams(window.location.search);
      const campaign = urlParams.get('utm_campaign');
    
      if (campaign) {
        $('.hero-section-wrapper').each(function () {
          var setting = $(this).data('setting');
          if (setting === campaign) {
            
            console.log('Active class added for:', setting);

            var mainProductSection = $('.shopify-section--main-product');
            var sectionToMove = $(this).parents('.shopify-section'); 
            if (mainProductSection.length && sectionToMove.length) {
              sectionToMove.insertBefore(mainProductSection);
              $(this).fadeIn('slow');
              $(this).parents('section').addClass('active');
            }

          }
        });
      }
    });

    
    $(document).on('click', '.special-hero-reviews-container .category', function () {
        var $container = $(this).closest('.special-hero-reviews-container');
        var selectedCategory = $(this).data('category');

        // Update active tab
        $container.find('.category').removeClass('active');
        $(this).addClass('active');

        // Show matching tab pane
        $container.find('.tab-pane').removeClass('show active');
        $container.find('[data-category="' + selectedCategory + '"]').addClass('show active');
      });
      $('.categories-container').find('.category').first().addClass('active').trigger('click');

  }
  


  
    // const header = document.querySelector('.fon-mobile-menu-container');
    // const headerQuizButton = document.querySelector('#header-quiz-button');
    // const sections = document.querySelectorAll('section');

    // function checkHeaderSection() {
    //   const headerRect = header.getBoundingClientRect();
    //   const headerMidY = headerRect.top + headerRect.height / 2;
    //   let darkSection = false;

    //   sections.forEach(section => {
    //     const secRect = section.getBoundingClientRect();
    //     if (headerMidY >= secRect.top && headerMidY <= secRect.bottom) {
    //       if (!section.classList.contains('section-dark')) {
    //         darkSection = true;
    //       }
    //     }
    //   });

    //   header.classList.toggle('dark-mode', darkSection);

    //   if ($('#header-quiz-button').length){
    //     headerQuizButton.classList.toggle('dark-mode', darkSection);
    //   }
    // }

    // // Run on load, scroll, resize
    // window.addEventListener('load', checkHeaderSection);
    // window.addEventListener('scroll', checkHeaderSection);
    // window.addEventListener('resize', checkHeaderSection);
    // document.addEventListener('DOMContentLoaded', checkHeaderSection);
  





  if ($('.section-page-reviews').length){
    let visibleCount = 10;

    $.getJSON("https://app.usefon.com/wp-json/fon/v1/reviews")
      .done(function(reviews) {
        const $container = $("#reviews");

        // Sort by date descending (newest first)
        reviews.sort(function(a, b) {
          return new Date(b.Date) - new Date(a.Date);
        });


        $('.review-stats .count').html(reviews.length);

        reviews.forEach(function(review) {
          const nameParts = review.review_author.split(" ");
          const firstName = nameParts[0];
          const lastInitial = nameParts.length > 1 ? nameParts[nameParts.length - 1][0] + "." : "";
          const displayName = `${firstName} ${lastInitial}`;

          let productImage = '';
          let productTitle = '';
          let productURL = '';

          switch (review.review_product) {
            case 'bundle':
              productImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/1_b62bb430-3a25-4f16-b2f9-1a04392cfc12.png?v=1743575099&width=40';
              productTitle = 'Bundle: OneLife Longevity + OneFit';
              productURL = 'https://usefon.com/products/bundle';
              break;
            case 'onefit':
              productImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Nav_OneFit_Collagen_40x.webp?v=1758856864';
              productTitle = 'OneFit 31-in-1 Post Workout Blend';
              productURL = 'https://usefon.com/products/onefit';
              break;
            case 'onelife':
              productTitle = 'OneLife NMN Blend';
              productImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Onelife_transparent_1500x1500_dc16c241-f123-4722-a01f-bbdf310c94d4.png?crop=center&height=40&v=1760588451&width=40';
              productURL = 'https://usefon.com/products/onelife-sachets';
              break;
          }

          const ratingCount = review.review_rating;

          let review_image = '';
          if (review.review_image){
            review_image = '<img  class="review-image" width="400" src="' + review.review_image + '" alt="' + displayName  + '"/>';
          }

          const reviewHTML = `
            <div class="col-md-6" style="display:none;">
              <div class="review" data-rating="${ratingCount}">
                <p class="display-name">${displayName}</p>

                <p class="date">${review.review_date}</p>
                    <div class="reviewx-container">
                      ${getStarsHTML(ratingCount)}
                    </div>
                    <p>${review.review_content}</p>

                    
              ${review_image}
                <hr>
                <p><a href="${productURL}"><img src="${productImage}"/><span>${productTitle}</span></a></p>
              </div>
            </div>
          `;

          $container.append(reviewHTML);
        });

        showReviews();
        initPhotos();

        // Generate star HTML based on rating
        function getStarsHTML(ratingCount) {
          let starsHTML = '';
          for (let i = 1; i <= 5; i++) {
            const starClass = i <= ratingCount ? 'active' : 'inactive';
            starsHTML += `
              <span class="review-star ${starClass}">
                <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Star_Symbol.png?v=1754024652" alt="">
              </span>
            `;
          }
          return starsHTML;
        }
        

        $('.rating-summary').each(function(){
            var ratingCount = $(this).attr('data-get-review');
      
            var totalCount = $('.review[data-rating="'+ratingCount+'"]').length;
      
            
            $(this).find('.total span').html(totalCount);


            var totalReviews = reviews.length;
            var percentage = (totalCount / totalReviews) * 100;
            $(this).find('.bar').css('width',percentage+'%');
            
        });

        
      })
      .fail(function(jqxhr, textStatus, error) {
        console.error("Failed to load reviews:", textStatus, error);
      });


    function initPhotos(){
      
    var lightbox = new SimpleLightbox('.review .review-image-link');
    }
    function showReviews() {
      const $reviews = $("#reviews > .col-md-6");
      $reviews.slice(0, visibleCount).fadeIn();

      if (visibleCount >= $reviews.length) {
        $("#show-more").hide();
      }
    }

    $("#show-more").on("click", function() {
      visibleCount += 10;
      showReviews();
    });


    $(document).on('click','#write-a-review',function(){
        window.location.href = 'https://www.trustpilot.com/review/usefon.com';
        // if ($(this).hasClass('active')){
        //   $(this).removeClass('active');
        //   $(this).html('Write a review');
        // }else{
        //   $(this).addClass('active');
        //   $(this).html('Hide write a review form');
        // }
        // $('.review-form-container').slideToggle();
    });



    $('.rating-summary').on('click', function () {
          const selectedRating = $(this).attr('data-get-review');

          // Optional: highlight the active filter
          $('.rating-summary').removeClass('selected');
          $(this).addClass('selected');

          // Filter reviews
          $('.review').parent('div').hide();
          $('.review[data-rating="'+selectedRating+'"]').parent('div').show();
          $('#show-more').hide();

          $('.review-stats').removeClass('active');
        });

      $('.review-stats').on('click', function () {

        $(this).toggleClass('active');

      });

  }
  


  $('.popup-inline-bottom-animation').magnificPopup({
    type: 'inline',
    callbacks: {
          open: function() {
              console.log('Popup body-inline-bottom');
              $('body').addClass('body-popup-slide');
          },
          close: function() {
              console.log('Popup closed');
              $('body').removeClass('body-popup-slide');
          }
    },
    mainClass: 'mfp-animate-bottom',
    closeMarkup: `
      <button title="%title%" type="button" class="mfp-close">
        <svg role="presentation" stroke-width="2" focusable="false" width="24" height="24" class="icon icon-close" viewBox="0 0 24 24">
          <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
        </svg>
      </button>
    `
  });

  $('.basic-magnific').magnificPopup({
    type: 'inline',
    closeMarkup: `
      <button title="%title%" type="button" class="mfp-close mfp-close-special">
        <svg role="presentation" stroke-width="2" focusable="false" width="24" height="24" class="icon icon-close" viewBox="0 0 24 24">
          <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
        </svg>
      </button>
    `
  });


    $(document).on('click','.inside-onefit-tabs .tab',function(){
    var dataAction = $(this).attr('data-action');

    $('.inside-onefit-tabs-content .tab-content').removeClass('active');
    $('.inside-onefit-tabs-content .tab-content[data-action="'+dataAction+'"]').addClass('active');

    $('.inside-onefit-tabs  .tab').removeClass('active');
    $(this).addClass('active');
  });






  
  // $(document).on('click', '.fon-video-container mux-player, .fon-video-container .fon-video-play', function () {

  $(document).on('click', '.fon-video-container.playing', function () {

    // Pause all other mux-players
      $('.fon-video-container mux-player').each(function () {
          this.pause();
          $('.fon-video-container').removeClass('playing');
      });

  });

  $(document).on('click', '.fon-video-container mux-player, .fon-video-container .fon-video-play', function () {
      // Find the mux-player inside this container
      var $player = $(this).closest('.fon-video-container').find('mux-player').get(0);
      var parent = $(this).parents('.fon-video-container');

      if (!parent.hasClass('clicked')){
        parent.addClass('clicked');
        // Pause all other mux-players
        $('.fon-video-container .review-video').each(function () {
            this.pause();
            $(this).parents('.fon-video-container').removeClass('playing');
        });

        // Toggle play/pause on the selected mux-player
        if ($player.paused) {
            $player.play();
            parent.addClass('playing');
        } else {
            $player.pause();
            parent.removeClass('playing');
        }
        
      }
      

      
  });


      var swiperFon = new Swiper('.swiper-fon-carousel', {
        slidesPerView: 1,
        spaceBetween: 60,
        // spaceBetween: 27,
        // loop: true,
        initialSlide: 1, // Start at 2nd slide (index 1)
        speed: 2000, // slide transition duration in ms (1.3s)
        breakpoints: {
            0: {
              slidesPerView: 1,
              centeredSlides: true,
              spaceBetween: 9,
            },
            768: {
              slidesPerView: 1,
              centeredSlides: true
            }
        },
        pagination: {
            el: '.swiper-fon-carousel .swiper-pagination',
            clickable: true
        }
        });

      // Pause all videos when the slide changes, then auto-play the active one
      swiperFon.on('slideChangeTransitionEnd', function () {
        // Pause all mux-players
        document.querySelectorAll('mux-player').forEach(function(player) {
          if (player && typeof player.pause === "function") {
            player.pause();
          }
        });

        $('.fon-video-container').removeClass('playing');

      });





  function toggleHeaderQuizButton() {
    var firstMain = $("#main section").first();
    if (!firstMain.length) return;

    var firstMainBottom = firstMain.offset().top + firstMain.outerHeight();
    var scrollPos = $(window).scrollTop();

    if (scrollPos >= firstMainBottom) {
      $("#header-quiz-button").addClass("d-md-block");
    } else {
      $("#header-quiz-button").removeClass("d-md-block");
    }
  }

  // Run on scroll + on load
  $(window).on("scroll load", toggleHeaderQuizButton);

    let reviewsCount = ($('.body-product-page').length) ? 7 : 5;
    reviewsCount = ($('.body-product-onelife ').length) ? 6 : reviewsCount;
    reviewsCount = ($('.body-product-onelife-jar').length) ? 5 : reviewsCount; // onelife-jar desktop: 5 per view (real carousel)


    let swiperReviewFon = new Swiper('.swiper-review-videos-carousel', {
      // slidesPerView: 'auto',
      spaceBetween: 25,
      loop: true,
      speed: 1000,
      initialSlide: 0,
       pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      breakpoints: {
        0: {
          spaceBetween: 15,
          slidesPerView: 1.2,
        },
        567: {
          spaceBetween: 20,
          slidesPerView: reviewsCount,
          initialSlide: 1,
        },
      }
    });
    

    // Pause all videos when the slide changes, then auto-play the active one
    swiperReviewFon.on('slideChangeTransitionEnd', function () {
      
      // Pause all mux-players
      // document.querySelectorAll('mux-player').forEach(function(player) {
      //   if (player && typeof player.pause === "function") {
      //     player.pause();
      //   }
      // });
      // $('.fon-video-container').removeClass('playing');
      
      // if ($(window).width() < 566){
      //   $player = $('.swiper-review-videos-carousel .swiper-slide-active mux-player').get(0);
      //   if ($player ){
      //     $player.play();
      //   }
      //   $('.swiper-review-videos-carousel .swiper-slide-active .fon-video-container').addClass('playing');
      // }
      

    });




   




    var $featureBtn = $('[data-action="benefits"]');
    var $ingredientBtn = $('[data-action="ingredient"]');
    var $featureItems = $('.feature-mobile p');
    var $featureMobile = $('.one-sachet-mobile-features');

    $featureBtn.on('click', function(){
        // Toggle spans
        $featureItems.each(function(){
        $(this).find('.feature').addClass('active');
        $(this).find('.ingredient').removeClass('active');
        });

        // Toggle button active state
        $featureBtn.addClass('active');
        $ingredientBtn.removeClass('active');

        // Toggle mobile container
        $featureMobile.addClass('show-features').removeClass('show-ingredients');
    });

    $ingredientBtn.on('click', function(){
        // Toggle spans
        $featureItems.each(function(){
        $(this).find('.feature').removeClass('active');
        $(this).find('.ingredient').addClass('active');
        });

        // Toggle button active state
        $ingredientBtn.addClass('active');
        $featureBtn.removeClass('active');

        // Toggle mobile container
        $featureMobile.addClass('show-ingredients').removeClass('show-features');
    });

    var diffSwiper = new Swiper('.swipe-different-slide', {
    loop: false, // set to true if you want it to restart at the first slide
    autoplay: {
      delay: 4000, // 4 seconds
      disableOnInteraction: false // keeps autoplay after manual swipe
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    // on: {
    //   init: function () {
    //     updateFraction(this);
    //   },
    //   slideChange: function () {
    //     updateFraction(this);
    //   }
    // }
  });

  function updateFraction(swiper) {
    var current = swiper.realIndex + 1;
    var total = swiper.slides.length;
    document.querySelector('.swiper-pagination-fraction').textContent = current + '/' + total;
  }

  const swiperCompetitionSlider = new Swiper('.swiper-competition-slider', {
    slidesPerView: 1.3, // show partial next/prev
    spaceBetween: 0,
    centeredSlides: true,
    initialSlide: 0, // ✅ Force it to start at the first slide
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      567: {
        spaceBetween: 20,
        slidesPerView: 3,
        centeredSlides: false,
      },
    }
  });

  $(document).on('click','.competition-nav .nav-item',function(){
    $(this).siblings().removeClass('active');
    $(this).addClass('active');

    var action = $(this).attr('data-action');
    $('.competition-tab').removeClass('active');
    $('.competition-tab[data-tab="'+action+'"]').addClass('active');

    swiperCompetitionSlider.slideTo(0);
    
  });

    // Trigger once on load
  $(window).trigger("scroll");





// $(window).on("scroll resize", function () {
//   $(".fon-detect-fadeout").each(function () {
//     var $el = $(this);
//     var rect = this.getBoundingClientRect();
//     var windowHeight = $(window).height();

//     var sectionHeight = rect.height;
//     if (sectionHeight <= 0) return; // skip empty elements

//     // How much height is visible inside viewport
//     var visibleHeight = Math.max(
//       0,
//       Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0)
//     );

//     var ratioVisible = visibleHeight / sectionHeight;

//     // Debug: see what happens per section
//     // console.log($el.index(), "top:", rect.top, "ratio:", ratioVisible);

//     // ✅ Condition: top has scrolled past AND only ≤35% left visible
//     if (rect.top < 0 && ratioVisible <= 0.35) {
//       $el.addClass("fon-section-fadeout");
//     } else {
//       $el.removeClass("fon-section-fadeout");
//     }
//   });
// });


  $('.open-klaviyo').magnificPopup({
    type: 'inline',
    midClick: true, // open on middle click too
    removalDelay: 300,
    mainClass: 'mfp-fade'
  });

  // DC - Collection
    new Swiper('.swiper-new-arival', {
      slidesPerView: 1.2,
      spaceBetween: 10,
      autoplay: {
        delay: 4500, // 3 seconds
        disableOnInteraction: false
      },
      pagination: {
        el: '.section-dc-collection .swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        769: {
          slidesPerView: 4,
          spaceBetween: 38,
        }
      }
    });


  


  if ($(window).width() > 1000) {



    let bgDarkness = 0; // global var
    function toggleFixOnTop() {
      document.querySelectorAll(".fix-when-viewport-reach-top").forEach((el) => {

        const rect = el.getBoundingClientRect();
        const sectionHeight = el.offsetHeight; // height of the section
        const scrollY = window.scrollY || window.pageYOffset;

        const sectionTop = scrollY + rect.top;       // section start
        const sectionProgress = (scrollY - sectionTop) / sectionHeight;

        const triggerPoint = -window.innerHeight * 0.65; // -50% past top

        console.log('sectionHeight:' + sectionHeight + ' / triggerPoint: ' + triggerPoint + ' / rect.top: ' + rect.top);
   


          // Add .fixed when scrolled past -50% viewport height
          if (rect.top <= triggerPoint) {
            el.classList.add("fixed");
          } else {
            el.classList.remove("fixed");
          }

          // clamp between 0–1
          let progress = Math.min(Math.max(sectionProgress, 0), 1);

          // start darkening only after 50%
          let adjusted = Math.max((progress - 0.65) / 0.65, 0);

          // cap the darkness to 0.8
          bgDarkness = Math.min(adjusted, 1) + .20;

          // instead of opacity, apply darker background to ::before
          el.style.setProperty("--bg-darkness", bgDarkness);


          
      });
    }

    

    function setFixedHeights() {
      document.querySelectorAll(".fix-when-viewport-reach-top").forEach((el) => {
        // Find the inner section (adjust selector if needed)
        const inner = el.querySelector("section") || el.firstElementChild;

        if (inner) {
          // Set the container’s height equal to the inner section’s height
          el.style.height = `${inner.offsetHeight}px`;
        }
      });
    }

    // ✅ Run once on load to set heights
    window.addEventListener("load", () => {

      if ($(window).width()  > 1040){
        setTimeout(function(){
          setFixedHeights();
        },1000);
      }

      toggleFixOnTop(); // run initial check
    });

    // ✅ Update on scroll and resize
    window.addEventListener("scroll", toggleFixOnTop);
    window.addEventListener("resize", () => {
      // setFixedHeights();
      toggleFixOnTop();
    });



  }else{

    $('.fon-section-slide-up-legacy').addClass('fon-section-slide-up');

     function toggleSlideUpVisibility() {
      const windowHeight = window.innerHeight;

      document.querySelectorAll(".fon-section-slide-up").forEach((el, i) => {
        const rect = el.getBoundingClientRect();
        const elementHeight = rect.height || el.offsetHeight;
        const visible = Math.max(0, Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0));

        // Unique active class
        const uniqClass = `active-${i + 1}`;

        if (visible >= elementHeight * 0.1) {
          el.classList.add("active", uniqClass);

          // Check previous sibling if it's a <section>
          const prev = el.previousElementSibling;
          if (prev && prev.tagName.toLowerCase() === "section") {
            prev.classList.add("active");
          }

        } else {
          // el.classList.remove("active", uniqClass);
        }
      });
    }

    // Attach once
    window.addEventListener("scroll", toggleSlideUpVisibility);
    window.addEventListener("resize", toggleSlideUpVisibility);
    window.addEventListener("load", toggleSlideUpVisibility);
  }

  document.addEventListener("DOMContentLoaded", () => {
    const target = document.querySelector(".btn-special");

      if (target) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                target.classList.add("in-viewport");
              } else {
                target.classList.remove("in-viewport");
              }
            });
          },
          {
            threshold: 0.1, // 10% visible triggers
          }
        );

        observer.observe(target);
      }
    });



    const swiperAboutTransparancy = new Swiper('.swiper-transparency', {
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: true,
      initialSlide: 0,
      loop: true, // ✅ Enables infinite loop
      autoplay: {
          delay: 3000, // ✅ 3 seconds
          disableOnInteraction: false, // Keeps autoplay after user interaction
      },
      pagination: {
          el: '.swiper-pagination-transparency',
          clickable: true
      }
  });


  // FON MUX
  $(document).on('click','.fon-video-lazy-container mux-player, .fon-video-lazy-container .fon-video-play, .fon-video-lazy-container .fon-video-poster',function(){
    var parent = $(this).parents('.fon-video-lazy-container');
      if (!parent.hasClass('clicked')){

        parent.addClass('clicked');

      if (!parent.hasClass('playing') && !parent.hasClass('loaded') ){
        // $('.fon-video-lazy-container').not($(this)).removeClass('playing');

        $('.fon-video-lazy-container mux-player').each(function () {
            this.pause();
            $(this).parents('.fon-video-lazy-container').removeClass('playing');
        });

        

        var dataKey = parent.attr('data-key');
        var dataThumbnailTime = parent.attr('data-thumbnail-time');

        if (!parent.hasClass('loaded')){
          var muxHTML = `
          <mux-player
            class="review-video"
            playback-id="${dataKey}"
            poster="https://image.mux.com/${dataKey}/thumbnail.webp?time=${dataThumbnailTime}"
            metadata-video-title="Test VOD"
            playsinline
            no-controls
            autoplay
            loop
            prefer-playback="mse"
            style="--controls:none;--media-object-fit:cover;--media-object-position:center;height:100%"
            ></mux-player>
            `;

          parent.append(muxHTML);
          // Reveal only when frames are actually rendering (kills the black-frame
          // flicker the old fixed 1s timeout caused); fallback in case the event
          // never fires (autoplay blocked etc.).
          var mp = parent.find('mux-player').get(0);
          var revealed = false;
          var reveal = function () {
            if (revealed) return;
            revealed = true;
            parent.addClass('loaded').addClass('playing');
          };
          mp.addEventListener('playing', reveal);
          setTimeout(reveal, 2500);

        }else{
          parent.find('mux-player').get(0).play();
        }
      }else{

        if (parent.hasClass('loaded')) {
          const player = parent.find('mux-player').get(0);
          if (player.paused) {
              player.play();
              parent.addClass('playing');
          } else {
              player.pause();
              parent.removeClass('playing');
          }
      }
        
        
      }

    }else{

        if (parent.hasClass('loaded')) {
          const player = parent.find('mux-player').get(0);
          if (player.paused) {
              player.play();
              parent.addClass('playing');
          } else {
              player.pause();
              parent.removeClass('playing');
          }
      }
    }
    
  });


  // SO GIFT Reviews
  if ($('.swiper-gift-review-videos-carousel').length){
    let swiperReviewFon = new Swiper('.swiper-gift-review-videos-carousel', {
      slidesPerView: 1.2,
      spaceBetween: 25,
      loop: false,
       pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      breakpoints: {
        567: {
          spaceBetween: 20,
          slidesPerView: 3.4
        },
      }
    });
  }


  $('.fon-open-supplement-facts').magnificPopup({
    type: 'inline',
    // callbacks: {
    //       open: function() {
    //           console.log('Popup body-inline-bottom');
    //           $('body').addClass('body-popup-slide');
    //       },
    //       close: function() {
    //           console.log('Popup closed');
    //           $('body').removeClass('body-popup-slide');
    //       }
    // },
    // mainClass: 'mfp-animate-bottom',
    // closeMarkup: `
    //   <button title="%title%" type="button" class="mfp-close">
    //     <svg role="presentation" stroke-width="2" focusable="false" width="24" height="24" class="icon icon-close" viewBox="0 0 24 24">
    //       <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
    //     </svg>
    //   </button>
    // `
  });

    


    $(document).on('click', '.review-pop-item img', function() {
      const key = $(this).parent().data('key');

      $(".review-vide-white-popup").css('opacity',0);
      $(".mfp-wrap").css('opacity',0);
      
      $.magnificPopup.open({
          items: {
              src: `<div class="white-popup hidden review-vide-white-popup"><mux-player playback-id="${key}" style="width:800px;height:450px;"></mux-player></div>`,
              type: 'inline'
          },
          mainClass: 'mfp-fade',
          closeBtnInside: true,
          fixedContentPos: false,
          callbacks: {
              open: function() {
                  setTimeout(function(){
                    const player = document.querySelector('.review-vide-white-popup mux-player');
                    player.muted = false;
                    player.play();
                    
                    
                    
                    setTimeout(function(){
                      $(".mfp-wrap").css('opacity',1);
                      $(".review-vide-white-popup").removeClass('hidden').animate({ opacity: 1 }, 400);
                    },500);

                  },1500);
              },
              close: function() {
                  document.querySelector('.review-vide-white-popup mux-player').pause();
              }
          }
      });
  });



    if ($('.hybrid-main-gallery').length){
      let mainSwiperHybrid;

      function initSwiper() {
        const thumbs = document.querySelectorAll(".thumb");

        // Initialize Swiper for desktop
        if (window.innerWidth >= 300 && !mainSwiperHybrid) {
          mainSwiperHybrid = new Swiper(".hybrid-main-gallery", {
            loop: false,
            spaceBetween: 10,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
          });

          // Thumbnail click navigation
          thumbs.forEach((thumb, index) => {
            thumb.addEventListener("click", () => {
              if (mainSwiperHybrid) mainSwiperHybrid.slideToLoop(index);
            });
          });

          // Set initial active thumbnail
          setActiveThumb(mainSwiperHybrid);

          // Update active thumbnail on slide change
          mainSwiperHybrid.on("slideChange", () => setActiveThumb(mainSwiperHybrid));

          // Function to sync active thumbnail
          function setActiveThumb(swiper) {
            thumbs.forEach((thumb) => thumb.classList.remove("active"));

            if (swiper && typeof swiper.realIndex === "number") {
              thumbs[swiper.realIndex].classList.add("active");
            }
          }
        }
        // Destroy Swiper if window is resized below 788px
        else if (window.innerWidth < 788 && mainSwiperHybrid) {
          mainSwiperHybrid.destroy(true, true);
          mainSwiperHybrid = null;
        }
      }

      // Run on load
      initSwiper();

      // Optional: Reinitialize on window resize
      window.addEventListener("resize", initSwiper);
    }

var $fxElements = $('.fx-conversion');

if ($fxElements.length === 0) return;

var rate = Shopify.currency.rate || 1;

$fxElements.each(function () {
  var $el = $(this);
  var rawText = $el.text().trim().replace(/,/g, '');

  var match = rawText.match(/^([^\d]*)([\d.]+)(\D*)$/);
  if (!match) return;

  var prefix = match[1] || '';
  var originalValue = parseFloat(match[2]);
  var suffix = match[3] || '';

  if (isNaN(originalValue)) return;

  var converted = Math.round(originalValue * rate);


  if ($el.hasClass('fx-conversion-total-saving')) {
    var annualSeparate = parseFloat($('.fx-conversion-separate').attr('data-conversion'));
    var annualPrice = parseFloat(String($('.option-quote-365').data('annual')).replace(/,/g, ''));
    if (!isNaN(annualSeparate) && !isNaN(annualPrice)) {
      converted = Math.round((annualSeparate - annualPrice));
    }

  }
  $el.attr('data-conversion',converted);


  var formatted = converted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');



  $el.text(prefix + formatted + suffix).addClass('active');
});



});
// re-upload marker: plain asset must exist after its .liquid twin was removed (2026-08-06)

/* FON UI kit accordion: .content needs a .content-inner wrapper for the
   grid-rows animation — wrap automatically so widgets opt in by class only. */
jQuery(function ($) {
  $('.fon-kit-acc .faq .content').each(function () {
    var $c = $(this);
    if (!$c.children('.content-inner').length) {
      $c.wrapInner('<div class="content-inner"></div>');
    }
  });
});

/* counterUp shim — registered on the FINAL jQuery.
   mi-custom.js embeds jQuery 1.12.4 and registers $.fn.counterUp on it, but it runs
   as a deferred body script BEFORE the footer jquery.min.js, whose 3.x build then
   overwrites window.jQuery — losing the plugin. Both mi-custom's own stats counters
   ($2(...).counterUp — resolves window.jQuery lazily) and
   fon-122025-content-with-stats.js then find no counterUp and the numbers never
   animate. DOMContentLoaded fires after every deferred script, so registering here
   lands on whichever jQuery won. No-op if a counterUp already exists. */
document.addEventListener('DOMContentLoaded', function () {
  var $ = window.jQuery;
  if (!$ || ($.fn && $.fn.counterUp)) return;
  $.fn.counterUp = function (opts) {
    var time = (opts && opts.time) || 400;
    var delay = (opts && opts.delay) || 10;
    return this.each(function () {
      var el = this;
      var text = (el.textContent || '').trim();
      var m = text.match(/^([^0-9]*)([0-9][0-9.,]*)(.*)$/);
      if (!m) return;
      var prefix = m[1], numStr = m[2], suffix = m[3];
      var decimals = (numStr.split('.')[1] || '').length;
      var hasComma = numStr.indexOf(',') > -1;
      var target = parseFloat(numStr.replace(/,/g, ''));
      if (isNaN(target)) return;
      var steps = Math.max(1, Math.floor(time / delay));
      var i = 0;
      var timer = setInterval(function () {
        i++;
        var val = target * (i / steps);
        if (i >= steps) { val = target; clearInterval(timer); }
        var out = val.toFixed(decimals);
        if (hasComma) out = out.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        el.textContent = prefix + out + suffix;
      }, delay);
    });
  };
});
